module.exports = __webpack_public_path__ + "static/media/person2.52a5a774.svg";